/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddDrinkBody,
    AddDrinkBodyFromJSON,
    AddDrinkBodyToJSON,
} from '../models/AddDrinkBody';
import {
    type DeleteDrink200Response,
    DeleteDrink200ResponseFromJSON,
    DeleteDrink200ResponseToJSON,
} from '../models/DeleteDrink200Response';

export interface AddDrinkRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * 
     */
    addDrinkBody: AddDrinkBody;
}

export interface DeleteDrinkRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * The ID of the drink
     */
    drinkId: string;
}

export interface UpdateDrinkRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * The ID of the drink
     */
    drinkId: string;
    /**
     * 
     */
    addDrinkBody: AddDrinkBody;
}

/**
 * 
 */
export class GroupDrinksApi extends runtime.BaseAPI {

    /**
     * Creates request options for addDrink without sending the request
     */
    async addDrinkRequestOpts(requestParameters: AddDrinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling addDrink().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addDrink().'
            );
        }

        if (requestParameters['addDrinkBody'] == null) {
            throw new runtime.RequiredError(
                'addDrinkBody',
                'Required parameter "addDrinkBody" was null or undefined when calling addDrink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drinks`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDrinkBodyToJSON(requestParameters['addDrinkBody']),
        };
    }

    /**
     * Add drink
     */
    async addDrinkRaw(requestParameters: AddDrinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.addDrinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add drink
     */
    async addDrink(requestParameters: AddDrinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addDrinkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteDrink without sending the request
     */
    async deleteDrinkRequestOpts(requestParameters: DeleteDrinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling deleteDrink().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDrink().'
            );
        }

        if (requestParameters['drinkId'] == null) {
            throw new runtime.RequiredError(
                'drinkId',
                'Required parameter "drinkId" was null or undefined when calling deleteDrink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drinks/{drinkId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{drinkId}', encodeURIComponent(String(requestParameters['drinkId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * delete drink
     */
    async deleteDrinkRaw(requestParameters: DeleteDrinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteDrink200Response>> {
        const requestOptions = await this.deleteDrinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteDrink200ResponseFromJSON(jsonValue));
    }

    /**
     * delete drink
     */
    async deleteDrink(requestParameters: DeleteDrinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteDrink200Response | null | undefined > {
        const response = await this.deleteDrinkRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Creates request options for updateDrink without sending the request
     */
    async updateDrinkRequestOpts(requestParameters: UpdateDrinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling updateDrink().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDrink().'
            );
        }

        if (requestParameters['drinkId'] == null) {
            throw new runtime.RequiredError(
                'drinkId',
                'Required parameter "drinkId" was null or undefined when calling updateDrink().'
            );
        }

        if (requestParameters['addDrinkBody'] == null) {
            throw new runtime.RequiredError(
                'addDrinkBody',
                'Required parameter "addDrinkBody" was null or undefined when calling updateDrink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/drinks/{drinkId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{drinkId}', encodeURIComponent(String(requestParameters['drinkId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AddDrinkBodyToJSON(requestParameters['addDrinkBody']),
        };
    }

    /**
     * Update drink
     */
    async updateDrinkRaw(requestParameters: UpdateDrinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateDrinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update drink
     */
    async updateDrink(requestParameters: UpdateDrinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDrinkRaw(requestParameters, initOverrides);
    }

}
